import React from 'react'
import { MultiUom } from 'Store/product/types'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { numberWithComma } from 'helpers/format'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Popover } from 'antd'

type Props = {
  masterUom?: MultiUom
  quantity: number
  currentUom?: MultiUom
}

const ProductUomMultiplier: React.FunctionComponent<Props> = props => {
  const { masterUom, quantity, currentUom } = props
  const total = (currentUom?.multiplier || 0) * quantity
  const titlPopup = `${currentUom?.uom_name} (${currentUom?.multiplier || 0} ${masterUom?.uom_name})`

  const renderTooltip = (label: any, title: any) => {
    return (
      <Popover
        content={<Content>{title}</Content>}
        trigger="hover"
        placement="bottom"
        title={<Title>{titlPopup}</Title>}
      >
        {label} <InfoCircleOutlined style={{ cursor: 'pointer' }} />
      </Popover>
    )
  }

  if (currentUom?.is_master) {
    return <div>{currentUom?.uom_name}</div>
  }

  return (
    <div>
      {renderTooltip(
        currentUom?.uom_name,
        `${quantity} ${currentUom?.uom_name} = ${numberWithComma(total)} ${masterUom?.uom_name}`,
      )}
    </div>
  )
}

const Title = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const Content = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

export default ProductUomMultiplier
